import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User } from 'lucide-react';
import { cn } from '@/lib/utils';
import SignInButton from '@/components/auth/SignInButton';
import { getMainNavigationItems } from '@/data/navigationData';

interface UnifiedBottomNavProps {
  session: boolean;
}

export const UnifiedBottomNav = ({ session }: UnifiedBottomNavProps) => {
  const location = useLocation();
  
  // Get key navigation items for bottom nav (limit to 4 for mobile UX)
  const bottomNavItems = getMainNavigationItems(session).slice(0, 4); // Limit to 4 to make room for auth/profile

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-background/98 backdrop-blur-md border-t border-border z-50 shadow-lg">
      <div className="flex justify-around items-center h-16 max-w-screen-xl mx-auto px-2">
        {bottomNavItems.map((item) => {
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.id}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center w-full h-full py-2 px-1",
                "text-muted-foreground hover:text-foreground transition-colors",
                isActive && "text-primary"
              )}
            >
              <div className="relative">
                <item.icon className="h-5 w-5" />
                {isActive && (
                  <span className="absolute -bottom-1.5 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 bg-primary rounded-full" />
                )}
              </div>
              <span className="text-xs mt-1 truncate max-w-[60px]">{item.label}</span>
            </Link>
          );
        })}
        
        {/* Auth/Profile Item */}
        {session ? (
          <Link
            to="/dashboard"
            className={cn(
              "flex flex-col items-center justify-center w-full h-full py-2 px-1",
              "text-muted-foreground hover:text-foreground transition-colors",
              location.pathname === "/dashboard" && "text-primary"
            )}
          >
            <div className="relative">
              <User className="h-5 w-5" />
              {location.pathname === "/dashboard" && (
                <span className="absolute -bottom-1.5 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 bg-primary rounded-full" />
              )}
            </div>
            <span className="text-xs mt-1 truncate max-w-[60px]">Profile</span>
          </Link>
        ) : (
          <SignInButton
            variant="ghost"
            size="sm"
            className={cn(
              "flex flex-col items-center justify-center w-full h-full py-2 px-1",
              "text-muted-foreground hover:text-foreground transition-colors h-auto"
            )}
            showIcon={false}
          >
            <div className="relative">
              <User className="h-5 w-5" />
            </div>
            <span className="text-xs mt-1 truncate max-w-[60px]">Sign In</span>
          </SignInButton>
        )}
      </div>
    </div>
  );
};